import {IHttpService, ILogService, IPromise, IQService} from 'angular';
import {TSBegruendungsCode} from '../../models/enums/TSBegruendungsCode';
import {TSBemerkungScope} from '../../models/enums/TSBemerkungScope';
import {TSSchadenfallEvent} from '../../models/enums/TSSchadenfallEvent';
import {TSSchadenfallStatus} from '../../models/enums/TSSchadenfallStatus';
import TSBankverbindung from '../../models/TSBankverbindung';
import TSDokument from '../../models/TSDokument';
import TSSchaden from '../../models/TSSchaden';
import TSSchadenfaelleSearchresultDTO from '../../models/TSSchadenfaelleSearchresultDTO';
import TSSchadenfall from '../../models/TSSchadenfall';
import TSSchadenfallPreFilterDTO from '../../models/TSSchadenfallPreFilterDTO';
import DVBernUtil from '../../utils/DVBernUtil';
import ITranslateService = angular.translate.ITranslateService;

export default class SchadenfallRS {
    serviceURL: string;
    http: IHttpService;

    static $inject = ['$http', 'REST_API', '$log', '$q', '$translate'];

    /* @ngInject */
    constructor($http: IHttpService, REST_API: string, private $log: ILogService, private $q: IQService,
                private $translate: ITranslateService,
    ) {
        this.serviceURL = REST_API + 'schadenfall';
        this.http = $http;
    }

    public searchSchadenfaelle(schadenfallSearch: any, prefilter: TSSchadenfallPreFilterDTO): IPromise<TSSchadenfaelleSearchresultDTO> {
        schadenfallSearch.prefilter = prefilter;
        return this.http.post(this.serviceURL + '/search/', schadenfallSearch, {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then((response: any) => {
            this.$log.debug('PARSING schadenfaelle REST array object', response.data);
            return new TSSchadenfaelleSearchresultDTO().deserialize(response.data);
        });
    }

    public findSchadenfall(schadenfallID: string): IPromise<TSSchadenfall> {
        return this.http.get(this.serviceURL + '/' + encodeURIComponent(schadenfallID))
                .then((response: any) => {
                    this.$log.debug('PARSING gesuch REST object ', response.data);
                    return new TSSchadenfall().deserialize(response.data);
                });
    }

    public update(schadenfall: TSSchadenfall): IPromise<TSSchadenfall> {
        DVBernUtil.setBankverbindungUndefinedIfNoIban(schadenfall);
        let sentGesuch = {};
        sentGesuch = schadenfall.serialize(sentGesuch);

        this.$log.debug('sending Schadenfall:');
        this.$log.debug(sentGesuch);

        return this.http.put(this.serviceURL, sentGesuch, {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then((response) => {
            return new TSSchadenfall().deserialize(response.data);
        });
    }

    public updateBankverbindung(schadenfall: TSSchadenfall): IPromise<TSBankverbindung> {
        const serializedSchadenfall = schadenfall.serialize({});
        return this.http.put(`${this.serviceURL}/bank`, serializedSchadenfall,
        ).then((response) => {
            return new TSBankverbindung().deserialize(response.data);
        });

    }

    public addSchaden(schadenfallId: any): IPromise<TSSchaden> {
        return this.http.post(this.serviceURL + '/addSchaden/' + encodeURIComponent(schadenfallId), null, {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then((response: any) => {
            this.$log.debug('PARSING schaden REST array object', response.data);
            return new TSSchaden().deserialize(response.data);
        });
    }

    public deleteSchaden(schadenfallId: any, schadenId: any): IPromise<any> {
        return this.http.delete(this.serviceURL + '/deleteSchaden/' + encodeURIComponent(schadenfallId) + '/' + encodeURIComponent(schadenId), {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }

    public handleTransition(schadenfall: TSSchadenfall, scope: TSBemerkungScope, begruendungsCode: TSBegruendungsCode | undefined, bemerkung: string,
                            event: TSSchadenfallEvent,
    ): IPromise<TSSchadenfall> {
        DVBernUtil.setBankverbindungUndefinedIfNoIban(schadenfall);
        let sentGesuch = {};
        sentGesuch = schadenfall.serialize(sentGesuch);

        this.$log.debug('sending Schadenfall:');
        this.$log.debug(sentGesuch);

        return this.http.post(this.serviceURL + '/transition', sentGesuch,
                {
                    params: {
                        begruendungsCode: begruendungsCode,
                        bemerkung: bemerkung,
                        event: event,
                        scope: scope,
                    },
                }).then((response) => {
            return new TSSchadenfall().deserialize(response.data);
        });
    }

    // handleTransition nur mit schadenfallId
    public handleTransitionForId(schadenfallId: string, scope: TSBemerkungScope, begruendungsCode: TSBegruendungsCode | undefined, bemerkung: string,
                                 event: TSSchadenfallEvent,
    ): IPromise<TSSchadenfall> {
        this.$log.debug('sending SchadenfallId:');
        this.$log.debug(schadenfallId);

        return this.http.post(this.serviceURL + '/transition/schadenfall', schadenfallId,
                {
                    params: {
                        begruendungsCode: begruendungsCode,
                        bemerkung: bemerkung,
                        event: event,
                        scope: scope,
                    },
                }).then((response) => {
            return new TSSchadenfall().deserialize(response.data);
        });
    }

    public updateVerantwortlicher(schadenfallId: string, verantwortlicher: string): IPromise<void> {
        //empty post with query params
        return this.http.post(this.serviceURL + '/verantwortlicher', null,
                {
                    params: {
                        schadenfallId: schadenfallId,
                        verantwortlicher: verantwortlicher,
                    },
                }).then((response) => {
            return this.$q.defer().resolve();  //void promise zurueckgeben
        });
    }

    public addSchaetzer(schadenfallId: string, selectedSchaetzerId: string): IPromise<void> {
        return this.http.post(this.serviceURL + '/schaetzer', null,
                {
                    params: {
                        schadenfallId: schadenfallId,
                        selectedSchaetzerId: selectedSchaetzerId,
                    },
                }).then((response) => {
            return this.$q.defer().resolve();  //void promise zurueckgeben
        });
    }

    public removeSchaetzer(schadenfallId: string, selectedSchaetzerId: string): IPromise<void> {
        return this.http.delete(this.serviceURL + '/schaetzer',
                {
                    params: {
                        schadenfallId: schadenfallId,
                        selectedSchaetzerId: selectedSchaetzerId,
                    },
                }).then((response) => {
            return this.$q.defer().resolve();  //void promise zurueckgeben
        });
    }

    public generateDeckblatt(schadenfallID: string): IPromise<TSDokument> {
        return this.http.get(`${this.serviceURL}/deckblatt/${this.$translate.use()}/${encodeURIComponent(schadenfallID)}`)
                .then((response: any) => {
                    this.$log.debug('PARSING gesuch REST object ', response.data);
                    return new TSDokument().deserialize(response.data);
                });
    }

    public updateStatus(schadenfallId: string, selectedStatus: TSSchadenfallStatus): IPromise<TSSchadenfall> {
        return this.http.post(`${this.serviceURL}/status`, null,
                {
                    params: {
                        schadenfallId: schadenfallId,
                        status: selectedStatus,
                    },
                }).then((response) => {
            return new TSSchadenfall().deserialize(response.data);
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/core/service/schadenfallRS.rest.ts